<template>
    <b-modal id="createuser" centered size="xl" ref="createUserModal" no-close-on-esc
        no-close-on-backdrop>
        <template #modal-header>
            <h5 class="modal-title">Add User</h5>
        </template>
        <template #default>
            <div class="create-user-body">
                <span class="errorMessage" v-if="v$.form.$error">Required fields cannot be blank.</span>
                <span class="errorMessage" v-if="v$.form.userName.$error && v$.form.userName.unvalidatior.$invalid">
                    <br />
                    Username cannot contain: |#,$%^&:&nbsp;?&lt;&gt;*{}~[]()"'/\+@= and spaces.
                </span>
                <span class="errorMessage" v-if="isUserCreationFailed && !v$.form.$error">User Creation failed.</span>
                <UserForm ref="userForm" :startTabIndex="4" :userDetails="form" :isConfirmUser="false"
                    @onFormDirty="formIsDirty" @onUserFormValue="setUserDetails" :isOpenInEditFlow="false"></UserForm>
                <AccessibleApplications
                    v-if="account.accountName != '' && account.cadebillAccountNo != '' && user_name != ''"
                    ref="accessibleApplications" :username="user_name" :accessibleApplicationAccount="account"
                    :isCreate="true"></AccessibleApplications>
            </div>
        </template>
        <template v-slot:modal-footer="{ ok, cancel, hide }" class="modal-footer">
            <b-button class="um-btn" @click="hideModal" tabindex="18">Back</b-button>
            <b-button class="um-btn" @click="cancelChanges" tabindex="17">Cancel</b-button>
            <b-button class="um-btn" @click="UpsertUser" v-b-modal.applicationSetting tabindex="16">Next</b-button>
        </template>
    </b-modal>
    <ApplicationSetting
        v-if="user_name != '' && form.firstName != '' && form.lastName != '' && form.userName != '' && form.phone != '' && form.email != '' && account.accountName != '' && account.accountNumber != ''"
        :userDetail="form" :accessibleApplications="accessibleApplicationList" :accessibleApplicationAccount="account"
        :applicationSettingTitle="applicationSettingTitle" :sfAccountId="accountId"
        :accountContactRoles="accountContactRoleList" :userApplicationPermissions="applicationPermissionList"
        :isAccountPermissionAccess="false" :associatedAccount="accountId" :isCustomerComunityEnabled="true"
        :showPermissions="true"></ApplicationSetting>
    <ErrorMessage ref="errorMessageRef" :errorMessage="error" callbackOnClose></ErrorMessage>
    <div>
        <b-modal id="CancelPromptModal" ref="cancelPromptModal" title="BootstrapVue" no-close-on-esc
            no-close-on-backdrop>
            <template #modal-header>
                <h5 class="modal-title">Confirmation</h5>
            </template>
            <template #default>
                <p>You have unsaved changes. Do you want to continue without saving?</p>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button class="um-btn" @click="CancelModal">Continue without saving</b-button>
                <b-button class="um-btn" @click="cancel()">Cancel</b-button>
            </template>
        </b-modal>
    </div>
    <NoticeModel ref="noticeModelRef" callbackOnClose></NoticeModel>
    <InfoPopup :popupmessage="info.message" :title="info.title" ref="InfoModel"></InfoPopup>
    <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
</template>
<script>
import UserForm from "./shared/UserForm";
import AccessibleApplications from "./shared/AccessibleApplications";
import { required, minLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import service from "../services/api.services";
import { eventbus } from "../main";
import ApplicationSetting from "./ApplicationSetting";
import { Component as Loading } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import ErrorMessage from "./shared/ErrorMessage";
import InfoPopup from "./shared/InfoPopup";
import NoticeModel from "./shared/NoticeModel.vue";
import enviromentVariable from '../constants/enviromentVariable';

const unvalidatior = helpers.regex(/^[^|#,$%^&:;?<>*{}~[\]()"'/+@=\s]*$/i
);
export default {
    setup() {
        return { v$: useVuelidate() };
    },
    name: "CreateUser",
    components: {
        UserForm,
        AccessibleApplications,
        ApplicationSetting,
        Loading,
        InfoPopup,
        ErrorMessage,
        NoticeModel
    },
    data() {
        return {
            form: {
                firstName: "",
                middleInitial: "",
                lastName: "",
                userName: "",
                title: "",
                phone: "",
                email: this.userEmailId,
                streetAddress: "",
                city: "",
                state: "",
                postalCode: "",
                country: "",
                languagePreference: "en"
            },
            selectedAccountNumber: this.accountNumber,
            primaryAccountNumber: "",
            accessibleApplicationList: [],
            defaultapplication: "Customer Community",
            applicationSettingTitle: "",
            showApplicationSettingModal: false,
            isUserCreationFailed: false,
            isLoading: false,
            fullPage: true,
            error: "",
            enabledApplicationList: [],
            searchedUserDetail: null,
            isDirty: false,
            accountContactRoleList: [],
            applicationPermissionList: [],
            user_name: this.$store.getters.username,
            account: {
                accountName: this.accountName,
                cadebillAccountNo: this.accountNumber
            },
            info: {
                message: "",
                title: ""
            },
            hasCaseFunctionalityAccess: false,
            isInvalidDateForNotice: enviromentVariable.isInvalidDateForNotice
        };
    },
    watch: {
        userEmailId: function (newValue) {
            this.form.email = newValue;
        },
        accountName: function (newValue) {
            this.account.accountName = newValue;
        },
        accountNumber: function (newValue) {
            this.account.cadebillAccountNo = newValue;
            this.selectedAccountNumber = newValue;
        }
    },
    mounted() {
        var that = this;
        this.GetAccountContactRolesByAccountId();
        this.GetPermissionForCustomerCommunity();
        this.GetAccessiblePermission(this.selectedAccountNumber);
        eventbus.on("setAccessibleApplications", function (data) {
            that.setAccessibleApplications(data);
        });
        eventbus.on("setRolesAndPermissions", function (data) {
            that.setRolesAndPermissions(data);
        });
    },
    props: {
        isNewUser: Boolean,
        userEmailId: String,
        accountNumber: String,
        accountName: String,
        accountId: String
    },
    created() {
        var that = this;
        //window.addEventListener("beforeunload", function(event) {
        //  that.Windowhandler(event);
        //});
        eventbus.on("setuserDetails", function ([payLoad, isnew, email]) {
            that.searchedUserDetail = payLoad;
            that.form.email = (email != null && email !== "") ? email : that.userEmailId;
            if (!isnew) {
                that.form.firstName = (that.searchedUserDetail.firstName);
                that.form.middleInitial = (that.searchedUserDetail.middleInitial);
                that.form.lastName = (that.searchedUserDetail.lastName);
                that.form.userName =
                    that.searchedUserDetail.userName != null
                        ? that.searchedUserDetail.userName
                        : "";
                that.form.phone = (that.searchedUserDetail.phone);
                that.form.title = (
                    that.searchedUserDetail.title != null
                        ? that.searchedUserDetail.title
                        : "");
                that.form.streetAddress = (that.searchedUserDetail.streetAddress);
                that.form.city = (that.searchedUserDetail.city);
                that.form.state = (that.searchedUserDetail.state);
                that.form.postalCode = (that.searchedUserDetail.postalCode);
                that.form.country = (that.searchedUserDetail.country);
                that.form.languagePreference = (that.searchedUserDetail.languagePreference);
            }
        });
        eventbus.on("GetRolesAndPermissionByAccountAndContactId", function (
            contactId,
            accountId
        ) {
            that.GetRolesAndPermissionByAccountAndContactId(contactId, accountId);
        });
    },
    validations: {
        form: {
            firstName: { required, minLength: minLength(1) },
            lastName: { required, minLength: minLength(1) },
            userName: { unvalidatior, required, minLength: minLength(1) },
            phone: { required }
        }
    },
    methods: {
        CancelModal: function () {
            if (this.$refs.cancelPromptModal) this.$refs.cancelPromptModal.hide();
            this.$emit("OnCreateUserModalCancel");
            this.closeAddUserFlow();
        },
        cancelChanges: function () {
            if (this.isDirty) {
                if (this.$refs.cancelPromptModal) this.$refs.cancelPromptModal.show();
                else this.$bvModal.show("CancelPromptModal");
            } else {
                this.$emit("OnCreateUserModalCancel");
                this.closeAddUserFlow();
            }
        },
        closeAddUserFlow: function () {
            this.hideModal();
            var that = this;
            this.$nextTick(function () {
                that.$bvModal.hide("searchemail");
            });
        },
        formIsDirty: function (isChange) {
            this.isDirty = isChange;
            this.$store.dispatch("setIsPageDirty", isChange);
        },
        ClearFormData: function () {
            this.form.userName = "";
            this.form.firstName = "";
            this.form.lastName = "";
            this.form.phone = "";
            this.form.title = "";
            this.form.middleInitial = "";
            this.form.streetAddress = "";
            this.form.city = "";
            this.form.state = "";
            this.form.postalCode = "";
            this.form.country = "";
            this.isUserCreationFailed = false;
        },
        hideModal: function () {
            this.ClearFormData();
            if (this.$refs.userForm && this.$refs.userForm.clearForm) this.$refs.userForm.clearForm();
            this.$nextTick(() => {
                this.v$.$reset();
            });
            this.$refs["createUserModal"].hide();
            this.isDirty = false;
            this.$store.dispatch("setIsPageDirty", false);
        },
        UpsertUser: function () {
            if (!this.$store.getters.isImpersonation) {
                this.getUserInfovalue();
                this.getUserAccessibleApplications();
                if (this.isNewUser || this.searchedUserDetail == null) {
                    this.CreateUser();
                } else {
                    this.UpdateUser();
                }
            }
            else {
                this.info.title = "Information Message";
                this.info.message = "This action is not allowed while impersonating";
                this.$refs.InfoModel.$refs["InfoPopupModel"].show();
            }
        },
        CreateUser: function () {
            this.saveOrCreateUserinfo();
        },
        setUserDetails: function (data) {
            this.form = data;
        },
        setAccessibleApplications: function (data) {
            this.accessibleApplicationList = data;
        },
        getUserAccessibleApplications: function () {
            this.$refs.accessibleApplications.getvalue();
        },
        getUserInfovalue: function () {
            this.$refs.userForm.getvalue();
        },
        saveOrCreateUserinfo: async function () {
            this.v$.form.$touch();
            if (this.v$.form.$error) {
                return false;
            } else {
                this.isLoading = true;
                var userObj = this.PrepareUserDetail();
                var userDetail = JSON.stringify(userObj);
                var that = this;
                await service
                    .CreateUser(userDetail)
                    .then(response => {

                        that.isDirty = false;
                        //this.$store.dispatch("setIsPageDirty", false);
                        if (response.data == "") {
                            that.isLoading = false;
                            that.applicationSettingTitle = "Customer Community";
                            that.$bvModal.show("applicationsetting");

                            if (that.hasCaseFunctionalityAccess) {
                                let isValidNotice = false;
                                isValidNotice = this.checkIsValidNotice();

                                if (isValidNotice) {
                                    if (that.$refs.noticeModelRef && that.$refs.noticeModelRef.$refs["noticeModel"])
                                        that.$refs.noticeModelRef.$refs["noticeModel"].show();
                                    else
                                        that.$bvModal.show("noticemodel");
                                }
                            }

                        } else {
                            console.log("Success");
                            that.isLoading = false;
                            that.error = response.data;
                            if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                                that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                            else
                                that.$bvModal.show("errormessage");
                        }
                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    });
            }
        },
        UpdateUser: async function () {
            this.v$.form.$touch();
            if (this.v$.form.$error) {
                return false;
            } else {
                this.isLoading = true;
                var userObj = this.PrepareUpdateUserDetail();
                var userDetail = JSON.stringify(userObj);
                var that = this;
                await service
                    .UpdateUser(userDetail)
                    .then(response => {
                        that.isDirty = false;
                        this.$store.dispatch("setIsPageDirty", false);
                        if (response.data == "") {
                            that.isLoading = false;
                            that.applicationSettingTitle = "Customer Community";
                            that.$bvModal.show("applicationsetting");
                        } else {
                            that.isLoading = false;
                            that.error = response.data;
                            if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                                that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                            else
                                that.$bvModal.show("errormessage");
                        }
                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    });
            }
        },
        PrepareUserDetail: function () {
            this.SetEnabledApplications();
            return {
                userName: (this.form.userName),
                firstName: (this.form.firstName),
                middleInitial: (this.form.middleInitial),
                lastName: (this.form.lastName),
                email: (this.form.email || this.userEmailId),
                title: (this.form.title),
                phone: (this.form.phone),
                streetAddress: (this.form.streetAddress),
                city: (this.form.city),
                state: (this.form.state),
                postalCode: (this.form.postalCode),
                country: (this.form.country),
                accountNumber: this.accountNumber,
                accountName: this.accountName,
                applicationDetails: this.enabledApplicationList,
                IsDisabled: false,
                IsLocked: false,
                SFAccountId: this.accountId,
                languagePreference: this.form.languagePreference
            };
        },
        PrepareUpdateUserDetail: function () {
            var sfContactId =
                typeof this.searchedUserDetail.sfContactId != "undefined" &&
                    this.searchedUserDetail.sfContactId != null &&
                    this.searchedUserDetail.sfContactId != ""
                    ? this.searchedUserDetail.sfContactId
                    : this.searchedUserDetail.contactId;
            this.SetEnabledApplications();
            var that = this;
            if (typeof this.searchedUserDetail.userPermission != "undefined") {
                this.searchedUserDetail.userPermission.forEach(function (permission) {
                    if (permission.direct == true) {
                        that.primaryAccountNumber = permission.sfAccountId;
                    }
                });
            } else this.primaryAccountNumber = this.searchedUserDetail.sfAccountId;

            return {
                UserName: (this.form.userName),
                FirstName: (this.form.firstName),
                MiddleInitial: (this.form.middleInitial),
                LastName: (this.form.lastName),
                Email: (this.form.email || this.userEmailId),
                Title: (this.form.title),
                Phone: (this.form.phone),
                StreetAddress: (this.form.streetAddress),
                City: (this.form.city),
                State: (this.form.state),
                PostalCode: (this.form.postalCode),
                Country: (this.form.country),
                languagePreference: (this.form.languagePreference),
                SFAccountId: this.primaryAccountNumber,
                SFContactId: sfContactId,
                AdfsGUID: this.searchedUserDetail.adfsGuid,
                ProfileId: this.searchedUserDetail.profileId,
                SfUserId: this.searchedUserDetail.sfUserId,
                SFAccountContactRelationId: this.searchedUserDetail
                    .sfAccountContactRelationId,
                applicationDetails: this.enabledApplicationList,
                AccountId: this.accountId,
                accountNumber: this.accountNumber,
                Enabled: true
            };
        },
        GetAccessiblePermission: async function (accountNumber) {
            var that = this;
            this.isLoading = true;
            await service
                .GetAccessiblePermission(this.$store.getters.username, accountNumber)
                .then(result => {
                    that.accessibleApplicationList = result.data;
                    if (this.isNewUser) {
                        if (
                            that.accessibleApplicationList != null &&
                            typeof that.accessibleApplicationList != "undefined"
                        ) {
                            that.accessibleApplicationList.forEach(function (application) {
                                if (application.applicationName == that.defaultapplication)
                                    application.isAccessible = true;
                                else application.isAccessible = false;
                            });
                        }
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                    that.accessibleApplicationList = [];
                    this.isLoading = false;
                });
        },
        SetEnabledApplications: function () {
            if (
                this.accessibleApplicationList != null &&
                this.accessibleApplicationList.length > 0
            ) {
                var that = this;
                if (
                    that.accessibleApplicationList != null &&
                    typeof that.accessibleApplicationList != "undefined"
                ) {
                    that.accessibleApplicationList.forEach(function (element) {
                        if (element.isAccessible) that.enabledApplicationList.push(element);
                    });
                }
            }
        },
        GetAccountContactRolesByAccountId: async function () {
            var that = this;
            that.accountContactRoleList = [];
            await service.GetAccountContactRolesByAccountId(that.accountId).then(
                data => {
                    if (
                        typeof data != "undefined" &&
                        data != null &&
                        data.roleHelpText != null &&
                        typeof data.roleHelpText != "undefined" &&
                        data.roleHelpText.length > 0
                    ) {
                        data.roleHelpText.forEach(function (roleitem) {
                            that.accountContactRoleList.push({
                                roleName: roleitem.role,
                                roleAccess: false,
                                roleHelpText: roleitem.helpText
                            });
                        });
                    }
                },
                error => {
                    console.log(error);
                    that.accountContactRoleList = [];
                }
            );
        },
        GetPermissionForCustomerCommunity: async function () {
            var that = this;
            that.hasCaseFunctionalityAccess = false;
            that.applicationPermissionList = [];
            await service.GetAllPermissions(that.accountId).then(
                data => {
                    if (data != null && data.length > 0) {
                        data.forEach(function (permissionGroup) {
                            if (permissionGroup.groupName == 'Cases Functionality') {
                                that.hasCaseFunctionalityAccess = true;
                            }

                            permissionGroup.isAccess = false;
                            permissionGroup.roles.forEach(function (role) {
                                role.isAccess = false;
                            });
                        });
                        that.applicationPermissionList = data;
                    }
                },
                error => {
                    console.log(error);
                    that.applicationPermissionList = [];
                }
            );
        },
        GetRolesAndPermissionByAccountAndContactId: async function (contactId, accountId) {
            var that = this;
            await service.GetUserPermissions(contactId, accountId).then(
                response => {
                    var data = response.data;
                    if (
                        typeof data != "undefined" &&
                        data != null &&
                        data.permissions != "" &&
                        typeof data.roles != "undefined" &&
                        data.roles != ""
                    ) {
                        data.roles.forEach(function (roleitem) {
                            that.accountContactRoleList.forEach(function (item) {
                                if (roleitem.indexOf(item.roleName) != -1) {
                                    item.roleAccess = true;
                                } else {
                                    item.roleAccess = false;
                                }
                            });
                        });
                        that.roles = that.accountContactRoleList
                            .filter(x => x.roleAccess == true)
                            .map(function (role) {
                                return role.roleName;
                            })
                            .join(",");
                        that.applicationPermissionList.forEach(function (permissionGroup) {
                            permissionGroup.roles.forEach(function (role) {
                                role.isAccess = false;
                                data.permissions.forEach(function (permission) {
                                    if (role.label.toLowerCase() == permission.toLowerCase()) {
                                        role.isAccess = true;
                                    }
                                });
                            });
                            permissionGroup.isAccess = true;
                            permissionGroup.roles.find(function (item) {
                                if (item.isAccess == false) {
                                    permissionGroup.isAccess = false;
                                }
                            });
                        });
                    }
                    that.isLoading = false;
                    if (that.showSetting == true)
                        that.$bvModal.show("applicationsetting");
                },
                error => {
                    console.log(error);
                }
            );
        },
        setRolesAndPermissions: function (accountContactRelation) {
            var that = this;
            if (
                accountContactRelation.roles != null &&
                accountContactRelation.roles != ""
            ) {
                var acRoles = accountContactRelation.roles.split(",");
                acRoles.forEach(function (roleitem) {
                    that.accountContactRoleList.forEach(function (item) {
                        if (roleitem.indexOf(item.roleName) != -1) {
                            item.roleAccess = true;
                        } else {
                            item.roleAccess = false;
                        }
                    });
                });
                that.roles = that.accountContactRoleList
                    .filter(x => x.roleAccess == true)
                    .map(function (role) {
                        return role.roleName;
                    })
                    .join(",");
            }
            if (
                accountContactRelation.permissions != null &&
                accountContactRelation.permissions.length > 0
            ) {
                var acPermissions = accountContactRelation.permissions[0].split(",");
                that.applicationPermissionList.forEach(function (permissionGroup) {
                    if (permissionGroup.groupName == 'Cases Functionality') {
                        that.hasCaseFunctionalityAccess = true;
                    }

                    permissionGroup.roles.forEach(function (role) {
                        role.isAccess = false;
                        acPermissions.forEach(function (permission) {
                            if (role.label.toLowerCase() == permission.toLowerCase()) {
                                role.isAccess = true;
                            }
                        });
                    });
                    permissionGroup.isAccess = true;
                    permissionGroup.roles.find(function (item) {
                        if (item.isAccess == false) {
                            permissionGroup.isAccess = false;
                        }
                    });
                });
            }
        },
        checkIsValidNotice() {
            var loggedinUsername = this.$store.getters.username;
            var hasDoNotShowAgainCheckboxchecked = document.cookie.includes('DoNotShowAgainFor' + loggedinUsername + 'Confirmed');

            return (this.isInvalidDateForNotice == 'False') && !hasDoNotShowAgainCheckboxchecked;

        }
    }
};
</script>
<style scoped>
.containerDiv {
    margin-bottom: 5px;
}

.ContentSection {
    font-weight: 600;
    font-size: 0.9rem;
}

.userContent td {
    padding-right: 30px;
}

.userContent td label {
    font-size: 0.9rem;
    margin-bottom: 0;
}

.hasError label {
    color: red !important;
}

.hasError input {
    border-color: red !important;
}

.userContent td input {
    width: 280px;
    border: 1px solid #8e8eca;
    border-radius: 0.2em;
    height: 1.7em;
    font-size: 0.9rem;
}

.userContent td textarea {
    width: 280px;
    border: 1px solid #8e8eca;
    border-radius: 0.2em;
    font-size: 0.9rem;
}

.applicationSection table {
    /*border-spacing: 0px;
        border-color: #8e8eca;
        background-color: #fff;
        border-collapse: collapse;
        overflow: auto;*/
    margin-top: 0.8em;
    width: 60%;
}

.applicationSection thead {
    border-bottom: 1.5px solid #8e8eca;
    border-top: 1.5px solid #8e8eca;
}

.applicationSection thead th {
    background-color: white;
    cursor: pointer;
    font-weight: normal;
    font-size: 0.9rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-collapse: collapse;
    padding: 3px 20px;
}

.applicationSection td {
    border-bottom: 1px solid #e0dddd;
    background-color: white;
    font-weight: normal;
    font-size: 0.9rem;
    padding: 4px 20px;
}

.adduserbtn {
    margin-left: 0.8em;
    background-color: #2c87f0;
    border: 1px solid #2c87f0;
    height: 2.6em;
    border-radius: 5px;
    font-size: 0.9rem;
    color: white;
    width: 5.2em;
}

.requiredinput {
    color: red;
}

.slider.round {
    border-radius: 34px;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #a1a6ab;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 20px;
    vertical-align: middle;
    margin-top: 8px;
    margin-bottom: 5px;
    font-weight: bold;
}

.svg-green {
    color: green !important;
    margin-right: 5px;
}

.svg-gray {
    color: gray !important;
    margin-right: 5px;
    cursor: pointer;
}

.errorMessage {
    color: red;
    font-size: 0.9rem;
    font-weight: 500;
}

.create-user-body {
    padding-bottom: 0rem;
    padding-left: 17px;
}

.PointerCursor {
    cursor: pointer;
}

.modal-backdrop {
    opacity: 0.5;
    transition: opacity 0.2s;
}

.modal-title {
    margin: auto;
}

.modal-footer {
    padding-right: 38px !important;
}

.modal-content {
    width: 98% !important;
}
</style>
